const getLayoutConfig = (theme = '', config = {}) => {
  if (!config.default) {
    console.error('Default config is required')
    return undefined
  }

  const currentConfig = config[theme] || {}

  return {
    ...config.default,
    ...currentConfig,
  }
}
export default getLayoutConfig
